import { render, staticRenderFns } from "./DespachoTicketComponent.vue?vue&type=template&id=602bc5f0&"
import script from "./DespachoTicketComponent.vue?vue&type=script&lang=js&"
export * from "./DespachoTicketComponent.vue?vue&type=script&lang=js&"
import style0 from "./DespachoTicketComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports